import classNames from 'classnames';
import { useRef } from 'react';
import { useSelector, useDispatch } from 'react-redux';

import useEscKeydown from 'common/hooks/useEscKeydown';
import useSidecartFocus from 'common/hooks/useSidecartFocus';
import { hideSideCart } from 'redux/cart/actions';

const Wrapper = (props) => {
  const { children } = props;

  const sidecartRef = useRef(null);
  const dispatch = useDispatch();
  const cartReducer = useSelector((state) => state.cart);
  const { isSideCartVisible } = cartReducer;

  useEscKeydown(() => handleEscKey());
  useSidecartFocus(sidecartRef.current);

  const handleEscKey = () => {
    if (isSideCartVisible) {
      dispatch(hideSideCart());
    }
  };

  return (
    <section
      className={classNames(
        'c7-side-cart',
        isSideCartVisible && 'c7-side-cart--visible'
      )}
      id="c7-side-cart"
      aria-labelledby="c7-side-cart__header__title"
      role="dialog"
      aria-modal="true"
      ref={sidecartRef}
    >
      {children}
    </section>
  );
};

export default Wrapper;
